/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  retrieveBasecasesFailure,
  retrieveBasecasesSuccess,
} from '@store/scenario/basecases/basecases-slice';
import { Basecase } from '@scenario/models/basecase.model';

export const retrieveBasecasesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('basecases/retrieveBasecases'),
    concatMap((_action: Action) =>
      from(dependencies.basecaseGateway.retrieveAll()).pipe(
        map((basecases: Basecase[]) => retrieveBasecasesSuccess(basecases)),
        catchError(() => of(retrieveBasecasesFailure('Fail to retrieve basecases'))),
      ),
    ),
  );
